import { LabelValueForText } from "components/ui/atoms/LabelValue";
import { getCommons } from "./fieldConverterHelpers";
import { LinkCell } from "./linkFieldView";

export const CharFieldView = ({ field, formattedValue }) => {
  return (
    <LabelValueForText
      label={field.label}
      sx={{ display: field.hidden ? "none" : "inherit" }}
      value={formattedValue || ""}
      isMissing={
        formattedValue === undefined ||
        formattedValue === null ||
        formattedValue.toString().trim() === ""
      }
    />
  );
};

export const charFieldConverter = ({ field, model }) => {
  return {
    ...getCommons({ field, model }),
    type: "string",
    valueFormatter: field.valueFormatter,
    renderCell: field.link ? LinkCell : undefined,
  };
};
